import { render } from "./DigitalTransfromScroll.vue?vue&type=template&id=29f4d705&scoped=true"
import script from "./DigitalTransfromScroll.vue?vue&type=script&lang=js"
export * from "./DigitalTransfromScroll.vue?vue&type=script&lang=js"

import "./DigitalTransfromScroll.vue?vue&type=style&index=0&id=29f4d705&lang=scss&scoped=true"

import exportComponent from "/Users/ganl/Code/vue-digital-transform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f4d705"]])

export default __exports__